<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col sm="12" class="text-center">
        <p class="text-h6 text-md-h4 text-center">Порядок обучения</p>
        <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
          <v-timeline-item
            v-for="(item, i) in items"
            :key="i"
            :color="item.color"
            :icon="item.icon"
            fill-dot
          >
            <v-card :color="item.color" dark>
              <v-card-title class="text-h6"> {{ item.title }} </v-card-title>
              <v-card-text class="white black--text pa-1 text-left">
                <p>{{item.text}}</p>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
    <span class="line line-1"></span>
  </v-container>
</template>

<script>
import { gsap } from "gsap";

export default {
  name: "RoadMap",
  data: () => ({
    items: [
      {
        title: "Базовые знания",
        text: "Изучаем языки программирования, графику,инструменты разработки и рисования",
        color: "main",
        icon: "mdi-star",
      },
      {
        title: "Свой проект",
        text: "Делаем несколько простых проектов",
        color: "alert",
        icon: "mdi-book-variant",
      },
      {
        title: "Совместный проект",
        text: "Проект вместе с другими программистами, дизайнерами, учимся работать в команде",
        color: "third",
        icon: "mdi-airballoon",
      },
      {
        title: "Готовый продукт",
        text: "Вы воплощаете вашу гениальную идею",
        color: "second",
        icon: "mdi-buffer",
      },
    ],
  }),
  mounted() {
    gsap.from(".v-timeline-item", {
      scrollTrigger: {
        trigger: ".v-timeline-item",
        start: "top bottom-=200px",
        once: true,
        toggleActions: "restart none none pause",
      },
      scale: 0.3,
      autoAlpha: 0,
      duration: 1,
    });
    gsap.from(".line-1", {
      scrollTrigger: {
        trigger: ".line-1",
        scrub: true,
        start: "top bottom",
        end: "top 200px",
      },
      scaleX: 0,
      transformOrigin: "left center",
      ease: "none",
    });
  },
};
</script>

<style lang="scss" scoped>
.line {
  width: 100%;

  height: 8px;
  margin: 0 0 10px 0;
  position: relative;
  display: inline-block;
  background-color: #67c293;
}
</style>